import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactCountryFlag from "react-country-flag"  ;
import ReactFlagsSelect from "react-flags-select" ;
import CRegion from './CRegion';



function CPays() {
  const paysIni = useSelector(state => state.ComPays)
  const dispatch = useDispatch()
  const[showregion, setShowregion]=useState(false)
  const[showbtnvalider, setShowbtnvalider]=useState(false)
  const [select, setSelect] = useState("BJ");
  const onSelect = (code) =>{
    setSelect(code);
    setShowregion(false);
    setShowbtnvalider(true);
  }
  const actionbouton = () => {
        dispatch({ 
                type:"ComPays/sendCodePays",
                payload: select
                });
        setShowregion(true)      
  }

  return (     
    <div className='px-auto mx-auto'>        
       <div className='col-6 espacehautbas' >         
              <ReactCountryFlag countryCode={select} svg  style={{ width: "2em", height: "2em"}}></ReactCountryFlag>
              <ReactFlagsSelect onSelect={onSelect} countries={['BJ', "BF", "CI", "CV", "GN", "GW", "ML", "MR", "NE", "SN", "TG", "TD"]} searchable="true" showSelectedLabel="true"/> 
        </div > 

         <div className='col-4'>
           { showbtnvalider && <button type="button" className='btn btn-success' onClick={actionbouton}> {paysIni.labelbouton} <i className='bi bi-hand-thumbs-up'></i></button >}
         </div>

        { showregion &&
           <div className='espacehautbas'>
              <CRegion/>
           </div>   
        } 
      
    </div>      
  );
}

export default CPays;
